import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { ForcePasswordChangeGate } from './ForcePasswordChangeGate';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/members" replace />;
  }
  // If admin reset this user's password, force a permanent password change before any protected UI loads.
  return <ForcePasswordChangeGate>{children}</ForcePasswordChangeGate>;
};
